import { createUseStyles } from 'react-jss';

const styles = {
  guidelinesContent: {
    fontSize: '1.6rem',
    lineHeight: '2.4rem',
    padding: ' 0 4rem 4rem',
  },
  typeTitle: {
    marginTop: '3rem',
  },
  sampleClass: {
    display: 'flex',
    position: 'relative',
  },
  sampleSelect: {
    '& div': {
      marginBottom: '1rem',
    },
  },
  sampleRemoveBtn: {
    left: '25rem',
    top: '4.7rem',
    paddingLeft: 0,
    position: 'absolute',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
